import { alpha, Button as MuiButton, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "linkStyles",
})<{ linkStyles: boolean }>(
  ({ theme }) => ({
    fontSize: "1em",
    textTransform: "none",
  }),
  ({ linkStyles }) => ({
    ...(linkStyles && {
      display: "flex",
      justifyContent: "flex-start",
      textAlign: "left",
      padding: "5px 0",

      "&:hover": {
        textDecoration: "underline",
        backgroundColor: "transparent",
      },
    }),
  })
);

export const PlusButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "isMini",
})<{ isMini?: boolean }>(
  ({ theme }) => ({
    minWidth: "35px",
    height: "35px",
    padding: "5px 10px",
    fontSize: "1em",
    lineHeight: "1.5em",
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.contrastText,

    "&:hover": {
      borderColor: alpha(theme.palette.primary.contrastText, 0.6),
    },
  }),
  ({ isMini, theme }) => ({
    ...(isMini && {
      backgroundColor: theme.palette.primary.contrastText,
      minWidth: "unset",
      height: "unset",
      padding: "3px",
      fontSize: "0.7rem",
      borderRadius: "4px",
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
    }),
  })
);

export const Title = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 24px 0",
});
